import React from "react";
import { useLanguage } from "../context/LanguageContext";
import "./../css/hardware.scss";

const Hardware: React.FC = () => {
  const { data } = useLanguage();

  return (
    <div className="px-2 py-3 hardware-lab">
      <div className="info-container px-4 py-4">
        <span className="section-title">{data.hardware.title}</span>
        <p className="blurb">{data.hardware.blurb}</p>
        <div className="hw-grid mt-4">
          {data.hardware.items.map((item, i) => (
            <div key={i} className="hw-item">
              <div className="hw-index">{`0${i + 1}`}</div>
              <h6 className="hw-name">{item.name}</h6>
              <p className="hw-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hardware;
